import { Fragment, PureComponent } from 'react';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import cns from 'classnames';

import { MakeGroupField } from 'components/forms/filters/vehicle/Make';
import { ModelGroupField } from 'components/forms/filters/vehicle/Model';
import { SubTypeGroupField } from 'components/forms/filters/vehicle/SubType';
import cn from './styles.local.less';

export default class MakeModelItem extends PureComponent {
  renderControlLabel({ className, ...props }) {
    return <ControlLabel className={cns(className, cn.label)} {...props} />;
  }

  render() {
    const props = {
      ...this.props,
      ControlLabel: this.renderControlLabel,
      className: cn.field,
      autoFocus: true,
    };

    return (
      <Fragment>
        <MakeGroupField {...props} />
        <ModelGroupField {...props} />
        <SubTypeGroupField {...props} />
      </Fragment>
    );
  }
}
